const constants = {
  mainWindowWidth: window.innerWidth - 235
};

export default constants;
